var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"maintenance-mode"},[_c('afterpay-logo'),_c('h1',[_vm._v("Maintenance Mode")]),_c('p',[_vm._v("We are doing some updates on our end. Sorry for the trouble!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }